module.exports = __webpack_public_path__ + "img/hear_no_evil_monkey.5bf5d415.gif";